<template>
  <b-container fluid>
    <b-row>
      <!-- RIGHT -->
      <b-col lg="8">
        <iq-card body-class="pb-0">
          <template v-slot:headerTitle>
            <h4 class="text-primary font-semibold">General Information</h4>
          </template>
          <template v-slot:body>
            <b-row>
              <b-col md="5">
                <div style="position: relative">
                  <div
                    class="user-profile text-center overflow-hidden"
                    style="position: relative"
                  >
                    <b-badge
                      style="
                        min-width: 120px;
                        position: absolute;
                        right: -28px;
                        top: 24px;
                        rotate: 45deg;
                      "
                      :variant="getStatusColor(fleetData?.status)"
                      class="px-4 py-1 rounded-none"
                    >
                      {{
                        fleetData?.status
                          ? fleetData?.status?.replace(/_/g, ' ')
                          : '-'
                      }}
                    </b-badge>
                    <template>
                      <img
                        v-if="
                          fleetData.img !== null ||
                          fleetData.img !== 'null' ||
                          fleetData.img !== 'undefined'
                        "
                        :src="fleetData.vehicleType.icon.url"
                        alt=""
                        class="img-fluid"
                        style="border-radius: 12px"
                      />
                      <img
                        v-else
                        :src="fleetData.img"
                        alt=""
                        class="img-fluid"
                        style="border-radius: 12px"
                      />
                    </template>
                  </div>
                  <div
                    class="w-100 d-flex justify-content-between align-items-center p-3"
                    style="position: absolute; bottom: 0; z-index: 2"
                  >
                    <div>
                      <div class="d-flex">
                        <img
                          src="https://flagsapi.com/ID/shiny/24.png"
                          alt="flags"
                          class="mr-2"
                        />
                        <h5 class="text-white">
                          <strong>{{ fleetData?.name ?? '-' }}</strong>
                        </h5>
                      </div>
                      <div class="d-flex align-items-center">
                        <p class="text-sm m-0 text-white">
                          {{ fleetData?.vehicleType?.name ?? '-' }}
                        </p>
                        <div
                          style="
                            height: 6px;
                            width: 6px;
                            border-radius: 50%;
                            background-color: white;
                          "
                          class="mx-2"
                        ></div>
                        <p class="text-sm m-0 text-white">
                          {{ fleetData?.company?.company ?? '-' }}
                        </p>
                      </div>
                    </div>
                    <b-dropdown
                      size="sm"
                      text="Small"
                      variant="none"
                      right
                      no-caret
                    >
                      <template slot="button-content">
                        <div>
                          <i
                            class="fa fa-ellipsis-h cursor-pointer text-white"
                            style="rotate: 90deg; margin-right: -12px"
                          ></i>
                        </div>
                      </template>
                      <b-dropdown-item
                        v-if="permissionEditFleet"
                        variant="primary"
                        @click="fetchFleetDetail(fleetData.id)"
                      >
                        <i class="fa fa-edit"></i>
                        Edit
                      </b-dropdown-item>
                      <b-dropdown-item
                        v-if="permissionDeleteFleet"
                        variant="danger"
                        @click="onDeleteFleet(fleetData)"
                      >
                        <i class="fa fa-trash"></i>
                        Delete
                      </b-dropdown-item>
                    </b-dropdown>
                  </div>
                </div>
              </b-col>
              <b-col md="7">
                <div class="w-100">
                  <table class="table table-striped w-100">
                    <tbody>
                      <tr>
                        <td width="35%">Call Sign</td>
                        <td width="65%" class="font-semibold">
                          <template
                            v-if="
                              fleetData.code === null ||
                              fleetData.code === 'null' ||
                              fleetData.code === 'undefined'
                            "
                          >
                            -
                          </template>
                          <template v-else>
                            {{ fleetData.code ?? '-' }}
                          </template>
                        </td>
                      </tr>
                      <tr>
                        <td width="35%">Effective Date</td>
                        <td width="65%" class="font-semibold">
                          {{ fleetData?.deliveryDate ?? '-' }}
                        </td>
                      </tr>
                      <tr>
                        <td>Ownership</td>
                        <td class="font-semibold">
                          <template
                            v-if="
                              fleetData.ownership === null ||
                              fleetData.ownership === 'null' ||
                              fleetData.ownership === 'undefined'
                            "
                          >
                            -
                          </template>
                          <template v-else>
                            {{ fleetData.ownership ?? '-' }}
                          </template>
                        </td>
                      </tr>
                      <!-- <tr>
                        <td width="35%">Flag</td>
                        <td width="65%" class="font-semibold">{{ fleetData?.flag ?? '-' }}</td>
                      </tr> -->
                      <tr>
                        <td width="35%">Year Build / Country</td>
                        <td width="65%" class="font-semibold">
                          <template
                            v-if="
                              fleetData.yearBuildCountry === null ||
                              fleetData.yearBuildCountry === 'null' ||
                              fleetData.yearBuildCountry === 'undefined'
                            "
                          >
                            -
                          </template>
                          <template v-else>
                            {{ fleetData.yearBuildCountry }}
                          </template>
                        </td>
                      </tr>
                      <!-- <tr>
                        <td>ID GPS</td>
                        <td class="font-semibold"
                          ><strong
                            ><template
                              v-if="
                                fleetData.idGps === null ||
                                fleetData.idGps === 'null' ||
                                fleetData.idGps === 'undefined'
                              "
                              >-</template
                            ><template v-else>{{
                              fleetData.idGps ?? '-'
                            }}</template></strong
                          ></td
                        >
                      </tr> -->
                    </tbody>
                  </table>
                </div>
              </b-col>
              <b-col md="12" class="mb-4 mt-3">
                <table class="table mt-0 mb-2 table-striped table-box-shadow">
                  <thead>
                    <tr>
                      <th colspan="2">Dimensions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="w-50">Length</td>
                      <!-- <td>{{ fleetData.dimension?.length.feet }}</td> -->
                      <td class="w-50 font-semibold">
                        {{ fleetData.dimension?.length.meter ?? '-' }} Meter
                      </td>
                    </tr>
                    <tr>
                      <td class="w-50">Width</td>
                      <!-- <td>{{ fleetData.dimension.width.feet }}</td> -->
                      <td class="font-semibold w-50">
                        {{ fleetData.dimension.width.meter ?? '-' }} Meter
                      </td>
                    </tr>
                    <tr>
                      <td class="w-50">Depth</td>
                      <!-- <td>{{ fleetData.dimension.depth.feet }}</td> -->
                      <td class="font-semibold">
                        {{ fleetData.dimension.depth.meter ?? '-' }} Meter
                      </td>
                    </tr>
                    <tr>
                      <td class="w-50">Draft</td>
                      <!-- <td class="w-50">{{ fleetData.dimension.draft.feet }}</td> -->
                      <td class="font-semibold">
                        {{ fleetData.dimension.draft.meter ?? '-' }} Meter
                      </td>
                    </tr>
                    <!-- <tr>
                      <td class="w-50">Speed</td>
                      <td colspan="2" class="text-center"
                        ><template
                          v-if="
                            fleetData.dimension.speed === null ||
                            fleetData.dimension.speed === 'null' ||
                            fleetData.dimension.speed === 'undefined'
                          "
                          >-</template
                        ><template v-else>{{
                          fleetData.dimension.speed ?? '-'
                        }}</template></td
                      >
                    </tr> -->
                  </tbody>
                </table>
              </b-col>
              <b-col md="12" class="mb-4">
                <table class="table table-striped">
                  <thead>
                    <th colspan="2">Power Information</th>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="w-50 font-semibold">Power Type</td>
                      <td class="w-50 font-semibold">Series</td>
                    </tr>
                    <tr v-for="(pwr, index) in fleetData.powers" :key="index">
                      <td class="w-50 font-semibold">
                        {{ pwr.powerType?.name ?? '-' }}
                      </td>
                      <td class="w-50 font-semibold">
                        {{ pwr.powerSeries?.name ?? '-' }} -
                        {{ pwr.powerSeries?.model ?? '-' }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-col>
              <b-col md="12">
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th colspan="2">Capcity Information</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="w-50 font-semibold">Type</td>
                      <td class="w-50 font-semibold">Series</td>
                    </tr>
                    <tr v-for="(pwr, index) in fleetData.robs" :key="index">
                      <td>{{ pwr.robType?.name ?? '-' }}</td>
                      <td>{{ pwr.robSeries?.name ?? '-' }}</td>
                    </tr>
                  </tbody>
                </table>
              </b-col>
            </b-row>
          </template>
        </iq-card>
      </b-col>
      <b-col lg="4">
        <iq-card class-name="iq-card-block iq-card-stretch iq-cad-height">
          <template v-slot:headerTitle>
            <h4 class="text-primary font-semibold">Active Crew</h4>
          </template>
          <template v-slot:body>
            <div>
              <b-form-input
                placeholder="Search crew name"
                class="mb-3"
                v-model="searchCrew"
              ></b-form-input>
            </div>
            <div
              style="height: 420px; position: relative"
              class="overflow-auto"
            >
              <table class="table table-striped">
                <thead>
                  <tr style="position: sticky; width: 100%; top: 0">
                    <th style="width: 60%">Crew Name</th>
                    <th style="width: 40%">Seaferer Code</th>
                  </tr>
                </thead>
                <tbody v-if="!loadingActiveCrew">
                  <template v-if="filteredCrews?.length">
                    <tr v-for="(crew, index) in filteredCrews" :key="crew.id">
                      <td style="width: 60%">
                        <div
                          class="d-flex align-items-center"
                          @click="
                            $router.push({
                              path: `/crewing/profile`,
                              query: {
                                user: 'crew',
                                id: crew.id,
                              },
                            })
                          "
                        >
                          <img
                            :src="
                              crew?.photo
                                ? crew?.photo
                                : $getInitials(crew?.fullname)
                            "
                            alt="crew-photo"
                            class="rounded-circle avatar-40 mr-2"
                          />
                          <div>
                            <p class="mb-0 font-semibold">
                              {{ crew?.fullname }}
                            </p>
                            <small>{{ crew?.position?.name ?? '-' }}</small>
                          </div>
                        </div>
                      </td>
                      <td style="width: 40%">
                        {{ crew?.seaferer_code || '-' }}
                      </td>
                    </tr>
                  </template>
                  <template v-else>
                    <tr>
                      <td colspan="2" align="center">No data available</td>
                    </tr>
                  </template>
                </tbody>
              </table>
              <div
                class="d-flex justify-content-center my-5"
                v-if="loadingActiveCrew"
              >
                <b-spinner />
              </div>
            </div>
            <!-- <router-link to="/ops/fleet-crew">
              <div class="btn btn-primary d-block mt-3"
                ><i class="fa fa-search"></i> VIEW CREW
                {{ fleetData?.name ?? '-' }}</div
              >
            </router-link> -->
          </template>
        </iq-card>
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="text-primary font-semibold">Support Document</h4>
          </template>
          <template v-slot:body>
            <div
              style="position: relative; max-height: 280px"
              class="overflow-auto"
            >
              <table class="table">
                <tbody>
                  <tr v-for="(doc, index) in fleetData.docs" :key="index">
                    <td style="width: 70%">
                      {{ doc?.fileName ?? '-' }}
                    </td>
                    <td class="text-center">
                      <button
                        class="btn btn-outline-primary btn-sm d-flex align-items-center"
                        @click="handleOpenFile(doc.url)"
                      >
                        Download
                        <i class="ri-download-2-line ml-1"></i>
                      </button>
                    </td>
                  </tr>
                  <tr v-if="fleetData.docs.length === 0">
                    <td colspan="3" class="text-center text-muted">
                      No documents found
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </template>
        </iq-card>
      </b-col>
      <!-- <b-col lg="12">
        <b-row>
          <b-col md="6" lg="3">
            <router-link to="/ops/certificate">
              <iq-card class-name="iq-card-block iq-card-stretch">
                <template v-slot:body>
                  <div
                    class="d-flex align-items-center justify-content-between"
                  >
                    <div class="text-left">
                      <h5 class="card-title mb-2 mt-2 text-primary">
                        <strong>TOTAL CERTIFICATE</strong>
                      </h5>
                      <h3 class="mb-0 line-height">{{
                        statsCertificateData.totalCertificate !== null
                          ? statsCertificateData.totalCertificate
                          : '-'
                      }}</h3>
                    </div>
                    <div class="rounded-circle iq-card-icon bg-primary">
                      <i class="las la-certificate"></i>
                    </div>
                  </div>
                </template>
              </iq-card>
            </router-link>
          </b-col>
          <b-col md="6" lg="3">
            <router-link to="/ops/certificate">
              <iq-card class-name="iq-card-block iq-card-stretch">
                <template v-slot:body>
                  <div
                    class="d-flex align-items-center justify-content-between"
                  >
                    <div class="text-left">
                      <h5 class="card-title mb-2 mt-2 text-primary">
                        <strong>EXPIRED</strong>
                      </h5>
                      <h3 class="mb-0 line-height">{{
                        statsCertificateData.totalExpired !== null
                          ? statsCertificateData.totalExpired
                          : '-'
                      }}</h3>
                    </div>
                    <div class="rounded-circle iq-card-icon bg-danger">
                      <i class="las la-exclamation"></i>
                    </div>
                  </div>
                </template>
              </iq-card>
            </router-link>
          </b-col>
          <b-col md="6" lg="3">
            <router-link to="/ops/certificate">
              <iq-card class-name="iq-card iq-card-block iq-card-stretch">
                <template v-slot:body>
                  <div
                    class="d-flex align-items-center justify-content-between"
                  >
                    <div class="text-left">
                      <h5 class="card-title mb-2 mt-2 text-primary">
                        <strong>1 BULAN AKAN EXPIRED</strong>
                      </h5>
                      <h3 class="mb-0 line-height">{{
                        statsCertificateData.totalOneMonth !== null
                          ? statsCertificateData.totalOneMonth
                          : '-'
                      }}</h3>
                    </div>
                    <div class="rounded-circle iq-card-icon bg-warning">
                      <i class="las la-tasks"></i>
                    </div>
                  </div>
                </template>
              </iq-card>
            </router-link>
          </b-col>
          <b-col md="6" lg="3">
            <iq-card class-name="iq-card-block iq-card-stretch">
              <template v-slot:body>
                <div class="d-flex align-items-center justify-content-between">
                  <div class="text-left">
                    <h5 class="card-title mb-2 mt-2 text-primary">
                      <strong>PROGRESS</strong>
                    </h5>
                    <h3 class="mb-0 line-height">{{
                      statsCertificateData.totalProcess !== null
                        ? statsCertificateData.totalProcess
                        : '-'
                    }}</h3>
                  </div>
                  <div class="rounded-circle iq-card-icon bg-success">
                    <i class="fa fa-clock-o"></i>
                  </div>
                </div>
              </template>
            </iq-card>
          </b-col>
        </b-row>
      </b-col> -->
      <b-col lg="12">
        <iq-card body-class="pb-0">
          <template v-slot:headerTitle>
            <h4 class="text-primary font-semibold">Fleet Summary</h4>
          </template>
          <template v-slot:body>
            <!-- Tabs -->
            <div class="d-flex gap-2 mb-4 overflow-auto pb-3">
              <div
                v-for="tab in tabs"
                :key="tab.key"
                class="tab-btn px-4 py-2 mr-2 text-nowrap"
                :class="{ active: activeTab === tab.key }"
                @click="activeTab = tab.key"
              >
                {{ tab.title }}
              </div>
            </div>

            <!-- Tab Content -->
            <div>
              <div v-if="activeTab === 'operational'">
                <Operational v-bind:isChildComponent="true" />
              </div>
              <div v-if="activeTab === 'certificate'">
                <Certificate v-bind:isChildComponent="true" />
              </div>
              <div v-if="activeTab === 'maintenance-board'">
                <!-- <MaintenanceSummaryBoard /> -->
                <MaintenanceFleetDetail />
              </div>
              <!-- <div v-if="activeTab === 'maintenance-init'">
                <MaintenanceSummaryInit />
              </div> -->
              <div v-if="activeTab === 'service-repair'">
                <ServiceRepairSummary :fleetId="$route.query.vehicleId" />
              </div>
              <div v-if="activeTab === 'list-initial'">
                <ListInitialTable :vehicle-id="vehicleId" />
              </div>
              <div v-if="activeTab === 'recommendation'">
                <ListInitialRecommendation :vehicle-id="vehicleId" />
              </div>
              <div v-if="activeTab === 'crewing'">
                <div class="iq-edit-list">
                  <div class="d-flex">
                    <div
                      class="tab-btn flex-fill text-center"
                      :class="{
                        active: activeSubTab === 'active_crew',
                      }"
                      @click="activeSubTab = 'active_crew'"
                    >
                      CREW ACTIVE {{ fleetData?.name }} (CURRENT)
                    </div>
                    <div
                      class="tab-btn flex-fill text-center"
                      :class="{
                        active: activeSubTab === 'history_crew',
                      }"
                      @click="activeSubTab = 'history_crew'"
                    >
                      HISTORY CREW {{ fleetData?.name }}
                    </div>
                  </div>

                  <div class="tab-content mt-3">
                    <div v-if="activeSubTab === 'active_crew'">
                      <!-- isi tab crew active -->
                    </div>
                    <div v-if="activeSubTab === 'history_crew'">
                      <!-- isi tab crew history -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="iq-edit-list-data">
                  <div id="pills-tabContent-2" class="tab-content">
                    <tab-content-item :active="true" id="invent">
                      <TabStock
                        :getListStock="getListStock"
                        :refreshMasterData="refreshMasterData"
                        :optionsFleets="optionsFleets"
                        :vehicle_type_id="fleetData.vehicleType?.id"
                        :list="listStock"
                        v-model="queryStock"
                      />
                    </tab-content-item>
                    <tab-content-item :active="false" id="invent-adjustment">
                      <TabStockAdjustment
                        :getListStockAdjustment="getListStockAdjustment"
                        :refreshMasterData="refreshMasterData"
                        :optionsFleets="optionsFleets"
                        :vehicle_type_id="fleetData.vehicleType?.id"
                        :list="listAdjustment"
                        v-model="queryAdjustment"
                      />
                    </tab-content-item>
                  </div>
                </div>
              </tab-content-item> -->
          </template>
        </iq-card>
      </b-col>
    </b-row>
    <b-modal
      id="edit-fleet"
      size="xl"
      :no-close-on-backdrop="true"
      :header-bg-variant="modal.headerBgVariant"
      :header-text-variant="modal.headerTextVariant"
      :body-bg-variant="modal.bodyBgVariant"
      :body-text-variant="modal.bodyTextVariant"
      hide-footer
    >
      <template v-slot:modal-header="{ close }">
        <h5>Edit Your Fleet</h5>
        <!-- Emulate built in modal header close button action -->
        <b-button size="md" variant="outline-danger" @click="close">
          <i class="fa fa-times"></i>
          Close
        </b-button>
      </template>
      <AddFleet
        v-bind:formData="fleetDetail"
        @childAction="$bvModal.hide('edit-fleet')"
      />
    </b-modal>
    <!-- End Edit Fleet Form -->
  </b-container>
</template>
<script>
import { latLng, icon } from 'leaflet'
import IqCard from '../../components/xray/cards/iq-card'
import AddFleet from '../MasterPages/AddFleet.vue'
import Operational from './Operational.vue'
import Certificate from '../Certificate/Certificate.vue'
import { xray } from '../../config/pluginInit'
import {
  fleetsActions,
  dashboardActions,
  voyagesActions,
  busdevActions,
} from '@src/Utils/helper'
import moment from 'moment'
import MaintenanceSummaryBoard from '@src/views/Maintenance/MaintenanceSummaryBoard'
import MaintenanceSummaryInit from '@src/views/Maintenance/MaintenanceSummaryInit'
import ServiceRepairSummary from '@src/views/Sr/ServiceRepairSummary'
import ListInitialTable from '@src/views/MI/ListInitialTable'
import ListInitialRecommendation from '@src/views/MI/ListInitialRecommendation'
import TabStock from './TabStock.vue'
import TabStockAdjustment from './TabStockAdjustment.vue'
import MaintenanceFleetDetail from '../Maintenance/Components/MaintenanceFleetDetail.vue'
import { previewFile } from '@/src/plugins/helpers'

export default {
  name: 'FleetInformation',
  components: {
    ListInitialRecommendation,
    ListInitialTable,
    MaintenanceSummaryInit,
    MaintenanceSummaryBoard,
    ServiceRepairSummary,
    IqCard,
    AddFleet,
    Operational,
    Certificate,
    TabStock,
    TabStockAdjustment,
    MaintenanceFleetDetail
  },
  data() {
    return {
      activeTab: 'operational',
      activeSubTab: 'active_crew',
      tabs: [
        { key: 'operational', title: 'OPERATIONAL' },
        { key: 'certificate', title: 'CERTIFICATE' },
        { key: 'maintenance-board', title: 'MAINTENANCE BOARD' },
        // { key: 'maintenance-init', title: 'MAINTENANCE INIT' },
        { key: 'service-repair', title: 'SERVICE & REPAIR' },
        { key: 'list-initial', title: 'ACCIDENT' },
        { key: 'recommendation', title: 'RECOMMENDATION' },
        { key: 'crewing', title: 'CREWING' },
      ],
      activityList: [],
      crewActiveInFleet: [],
      loadingActiveCrew: false,
      crewHistoryInFleet: [],
      defaultPhoto: require('../../assets/images/user/11.png'),
      // MAPS
      zoom: 7,
      center: latLng(-2.548926, 118.0148634),
      url: 'https://api.maptiler.com/maps/hybrid/{z}/{x}/{y}.jpg?key=T7IfHizkxdz98X76UCBi',
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      currentZoom: 11.5,
      currentCenter: latLng(-2.548926, 118.0148634),
      showParagraph: true,
      mapOptions: {
        zoomSnap: 0.5,
        zoomControl: false,
      },
      showMap: true,
      withPopup: latLng(-2.548926, 118.0148634),
      icon: icon({
        iconUrl:
          'https://upload.wikimedia.org/wikipedia/commons/thumb/a/ab/Tugboat_diagram-en.svg/2560px-Tugboat_diagram-en.svg.png',
        iconSize: [62, 67],
        iconAnchor: [16, 37],
      }),
      iconSize: [62, 67],
      iconAnchor: [16, 37],
      lang: {
        formatLocale: {
          // MMMM
          months: [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December',
          ],
          // MMM
          monthsShort: [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec',
          ],
          // dddd
          weekdays: [
            'Sunday',
            'Monday',
            'Tuesday',
            'Wednesday',
            'Thursday',
            'Friday',
            'Saturday',
          ],
          // ddd
          weekdaysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          // dd
          weekdaysMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
          // first day of week
          firstDayOfWeek: 0,
          // first week contains January 1st.
          firstWeekContainsDate: 1,
        },
        monthBeforeYear: false,
      },
      dateRange: [new Date(2021, 5, 1), new Date(2021, 5, 30)],
      // END MAPS DATA
      // API DATA
      modal: {
        show: false,
        variants: [
          'primary',
          'secondary',
          'success',
          'warning',
          'danger',
          'info',
          'light',
          'dark',
        ],
        headerBgVariant: 'light',
        headerTextVariant: 'dark',
        bodyBgVariant: 'default',
        bodyTextVariant: 'dark',
        footerBgVariant: '#000000',
        footerTextVariant: 'dark',
      },
      loading_voyage_history: false,
      loading_voyage_matrix: false,
      historiesParamsDate: [new Date(2020, 1, 1), new Date()],
      voyageHistories: [],
      voyageMatrix: [],

      optionsItems: [],
      optionsFleets: [],

      fleetData: {
        latitude: '',
        longitude: '',
        company: {},
        vehicleType: {
          icon: {},
        },
        dimension: {
          length: {},
          width: {},
          depth: {},
          draft: {},
        },
        docs: [],
        powers: [],
        robs: [],
      },
      sclDateFilter: {
        startDate: null,
        endDate: null,
      },
      sclData: [],
      fleetDetail: null,
      loadingForm: false,
      statsCertificateData: {
        totalCertificate: null,
        totalExpired: null,
        totalOneMonth: null,
        totalProcess: null,
      },

      selectedJabatan: 1,
      optionsJabatan: [
        { value: '1', text: 'Master' },
        { value: '2', text: 'Chief Officer' },
        { value: '3', text: 'Second Officer' },
        { value: '4', text: 'Chief Engineer' },
        { value: '5', text: 'Second Engineer' },
        { value: '6', text: 'Third Engineer' },
        { value: '7', text: 'Oiler' },
        { value: '8', text: 'Cooker' },
      ],
      patientChart: {
        series: [
          {
            name: 'Reason Day',
            data: [44, 55, 41, 67, 22, 43, 21, 33, 45, 31, 15, 14, 41],
          },
        ],
        annotations: {
          points: [
            {
              x: 'Bananas',
              seriesIndex: 0,
              label: {
                borderColor: '#775DD0',
                offsetY: 0,
                style: {
                  color: '#fff',
                  background: '#775DD0',
                },
                text: 'Bananas are good',
              },
            },
          ],
        },
        chart: {
          height: 300,
          type: 'bar',
        },
        colors: ['#334697'],
        dataLabels: {
          enabled: false,
        },
        grid: {
          row: {
            colors: ['#fff', '#f2f2f2'],
          },
        },
        xaxis: {
          labels: {
            rotate: -45,
          },
          categories: [
            'Run',
            'Tech',
            'Dock',
            'Weather',
            'Ops',
            'Waiting Loading',
            'Waiting Unloading',
            'Doc POL',
            'Doc POD',
            'Crewing',
            'Finance',
            'Loading',
            'Unloading',
          ],
          tickPlacement: 'on',
        },
      },
      DockingChart: {
        series: [
          {
            name: 'Reason Day',
            data: [
              44, 55, 41, 67, 22, 43, 21, 33, 45, 31, 15, 14, 41, 78, 68, 74,
              15, 65,
            ],
          },
        ],
        annotations: {
          points: [
            {
              x: 'Bananas',
              seriesIndex: 0,
              label: {
                borderColor: '#775DD0',
                offsetY: 0,
                style: {
                  color: '#fff',
                  background: '#775DD0',
                },
                text: 'Bananas are good',
              },
            },
          ],
        },
        chart: {
          // height: 275,
          type: 'bar',
        },
        colors: ['#334697'],
        dataLabels: {
          enabled: false,
        },
        grid: {
          row: {
            colors: ['#fff', '#f2f2f2'],
          },
        },
        xaxis: {
          labels: {
            rotate: -45,
          },
          categories: [
            'Blasting / Painting',
            'Carpentry',
            'Cleaning',
            'Docking / Undocking',
            'Electrical',
            'Facility',
            'General Service',
            'Outfitting',
            'Navigation / Radio',
            'Piping',
            'Propulsion System',
            'Steel Work',
            'Mechanical (AE 1)',
            'Mechanical (ME 1)',
            'Mechanical (ME 2)',
            'Mechanical (AE 2)',
            'Gearbox 1',
            'Gearbox 2',
          ],
          tickPlacement: 'on',
        },
      },
      MaintenanceChart: {
        chart: {
          height: 265,
          type: 'bar',
        },
        colors: ['#334697'],
        plotOptions: {
          bar: {
            horizontal: true,
          },
        },
        dataLabels: {
          enabled: false,
        },
        series: [
          {
            name: 'Total Maintenance',
            data: [
              50, 78, 21, 47, 15, 45, 73, 81, 57, 94, 11, 47, 66, 87, 72, 150,
              43, 65,
            ],
          },
        ],
        xaxis: {
          categories: [
            'Accomodation',
            'Hull & Load Line',
            'Tank',
            'Mooring & Anchor Equipment',
            'Fire Fighter Appliance',
            'Life Saving Appliance',
            'Navigation',
            'Radio Equipment',
            'Main Engine',
            'Aux Engine',
            'Gearbox',
            'Engine & Other Machinery',
            'Propulsion & Rudder System',
            'Electrical & Component Part',
            'Anchor Machinery',
            'Cargo Engine',
            'Cargo Pump',
            'Navigation Lamp',
          ],
        },
      },
      MaintenanceCost: {
        chart: {
          height: 261,
          type: 'bar',
        },
        colors: ['#F9A264'],
        plotOptions: {
          bar: {
            horizontal: true,
          },
        },
        dataLabels: {
          enabled: false,
        },
        series: [
          {
            name: 'Total Cost',
            data: [
              9016096, 3468668, 4091132, 601386, 9209250, 4751063, 9564460,
              857012, 5766106, 7471733, 5904718, 8644773, 4091123, 5000960,
              9446271, 3221431, 5105702, 7036968,
            ],
          },
        ],
        xaxis: {
          categories: [
            'Accomodation',
            'Hull & Load Line',
            'Tank',
            'Mooring & Anchor Equipment',
            'Fire Fighter Appliance',
            'Life Saving Appliance',
            'Navigation',
            'Radio Equipment',
            'Main Engine',
            'Aux Engine',
            'Gearbox',
            'Engine & Other Machinery',
            'Propulsion & Rudder System',
            'Electrical & Component Part',
            'Anchor Machinery',
            'Cargo Engine',
            'Cargo Pump',
            'Navigation Lamp',
          ],
        },
      },
      ServiceRepair: {
        chart: {
          width: 380,
          type: 'pie',
        },
        labels: ['Welding', 'Mechanical', 'Electrical', 'General Service'],
        series: [44, 55, 13, 43],
        colors: ['#0C9BAB', '#F9A264', '#e64141', '#ffd400'],
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
              legend: {
                position: 'bottom',
              },
            },
          },
        ],
      },
      radialChat: {
        type: 'radial-pie',
        height: 280,
        data: [
          {
            country: 'Minor',
            value: 401,
          },
          {
            country: 'Medium',
            value: 300,
          },
          {
            country: 'Major',
            value: 200,
          },
        ],
      },
      info: {
        cases: 0,
        recovered: 0,
        deaths: 0,
      },
      config: {
        dateFormat: 'Y-m-d',
        inline: true,
        height: 500,
      },
      events: [
        {
          title: 'Docking Intermediate',
          start: '2021-04-08',
          color: '#fc9919',
        },
        {
          title: 'Long Event',
          start: '2019-12-07',
          end: '2019-12-10',
          color: '#ffc107', // override!
        },
        {
          groupId: '999',
          title: 'Repeating Event',
          start: '2021-04-09T16:00:00',
          color: '#17a2b8',
        },
        {
          groupId: '999',
          title: 'Repeating Event',
          start: '2021-04-10T16:00:00',
          color: '#17a2b8',
        },
        {
          title: 'Conference',
          start: '2021-04-15',
          end: '2021-04-16',
          color: '#27e3f4', // override!
        },
        {
          title: 'Meeting',
          start: '2021-04-25T10:30:00',
          end: '2021-04-26T12:30:00',
          color: '#0084ff',
        },
        {
          title: 'Lunch',
          start: '2021-04-28T12:00:00',
          color: '#777D74',
        },
      ],

      queryStock: '',
      listStock: {
        data: [],
        meta: null,
      },

      queryAdjustment: '',
      listAdjustment: {
        data: [],
        meta: null,
      },
      searchCrew: '',
    }
  },
  computed: {
    filteredCrews() {
      return this.crewActiveInFleet.filter((crew) => {
        const query = this.searchCrew.toLowerCase()
        return (
          crew?.fullname?.toLowerCase().includes(query) ||
          crew?.position?.name?.toLowerCase().includes(query)
        )
      })
    },
    permissionEditFleet() {
      let hasAccess = JSON.parse(localStorage.getItem('profile')).menu.find(
        (obj) => obj.menu === 'Fleets'
      ).update
      return hasAccess
    },
    permissionDeleteFleet() {
      let hasAccess = JSON.parse(localStorage.getItem('profile')).menu.find(
        (obj) => obj.menu === 'Fleets'
      ).delete
      return hasAccess
    },
    vehicleId() {
      const { vehicleId } = this.$route.query

      if (!vehicleId) {
        return null
      }

      return Number(vehicleId)
    },

    defaultDate() {
      const currentDate = moment()

      let dayOfYear = moment().startOf('year')
      let substractedDayOfYear = dayOfYear.subtract(1, 'year')

      const startDate =
        currentDate.month() === 0
          ? substractedDayOfYear
          : moment().startOf('year')
      const endDate = currentDate

      const formattedStartDate = new Date(startDate)
      const formattedEndDate = new Date(endDate)

      this.dateRange = [formattedStartDate, formattedEndDate]

      return this.dateRange
    },
  },
  // created(){
  //   this.getListStock = _.debounce(this.getListStock, 500)
  //   this.getListStockAdjustment = _.debounce(this.getListStockAdjustment, 500)
  // },
  async mounted() {
    xray.index()

    await this.fetchFleet()
    await this.fetchStatsCertificate()
    await this.getLastActivity()
    await this.fetchCrewInFleet()
    await this.fetchListFleets()

    await this.getListStock(1, this.defaultDate)
    await this.getListStockAdjustment(1, this.defaultDate)
  },
  methods: {
    ...busdevActions,
    ...voyagesActions,
    ...fleetsActions,
    ...dashboardActions,
    getStatusColor(status) {
      let color = 'danger'
      if (status) {
        switch (status?.toLowerCase()) {
          case 'active':
            color = 'success'
            break
          case 'sell':
            color = 'primary'
            break
          case 'on_loan':
            color = 'warning'
            break
        }
        return color
      } else {
        return color
      }
    },
    refreshMasterData() {
      this.getListStock(1, this.defaultDate)
      this.getListStockAdjustment(1, this.defaultDate)
    },
    async getListStock(page, range) {
      let params = {
        vehicle_id: this.$route.query.vehicleId,
        params: {
          page: page || 1,
          limit: 20,
          search: this.queryStock,
          start_date: range?.[0]
            ? moment(range?.[0]).format('YYYY-MM-DD')
            : null,
          end_date: range?.[1] ? moment(range?.[1]).format('YYYY-MM-DD') : null,
        },
      }

      if (!params.params.search) delete params.params.search
      if (!params.params.start_date) delete params.params.start_date
      if (!params.params.end_date) delete params.params.end_date

      let res = await this.getVehicleStockData(params)

      if (res.data.status === true && res.data.data.result?.length > 0) {
        this.listStock.data = res.data?.data?.result
        this.listStock.meta = {
          page: res.data.data?.page,
          limit: res.data.data?.limit,
          totalPage: res.data.data?.totalPage,
        }
      } else {
        this.listStock.data = []
        this.listStock.meta = null
      }
    },
    async getListStockAdjustment(page, range) {
      let params = {
        page: page || 1,
        search: this.queryAdjustment,
        vehicle_id: this.$route.query.vehicleId,
        start_date: range?.[0] ? moment(range?.[0]).format('YYYY-MM-DD') : null,
        end_date: range?.[1] ? moment(range?.[1]).format('YYYY-MM-DD') : null,
      }

      if (!params.search) delete params.search
      if (!params.start_date) delete params.start_date
      if (!params.end_date) delete params.end_date

      let res = await this.getStockAdjustments(params)

      if (res.data.status === true && res.data.data.result?.length > 0) {
        this.listAdjustment.data = res.data?.data?.result
        this.listAdjustment.meta = {
          page: res.data.data?.page,
          limit: res.data.data?.limit,
          totalPage: res.data.data?.totalPage,
        }
      } else {
        this.listAdjustment.data = []
        this.listAdjustment.meta = null
      }
    },

    handleOpenFile(url) {
      previewFile(url)
      // window.open(url)
    },
    async fetchListFleets() {
      this.optionsFleets = []
      let params = {
        page: 1,
        perPage: 9999,
        showAll: true,
        active: true,
      }

      let res = await this.getFleets(params)

      if (res.status) {
        if (res.data && res.data?.length > 0) {
          this.optionsFleets = res.data.filter(
            (obj) => obj.vehicleType?.id === this.fleetData.vehicleType?.id
          )
        }
      }
    },
    async fetchFleet() {
      const res = await this.getFleetById(this.vehicleId)

      if (res.status == 'success') {
        this.fleetData = res.data
        console.log('fleet', this.fleetData)
      } else {
        this.fleetData = {}
        this.$swal(`Oops!`, res.data, 'error')
      }
    },
    async fetchFleetDetail(id) {
      const res = await this.getFleetById(id)

      if (res.status == 'success') {
        this.fleetDetail = res.data
        this.$bvModal.show('edit-fleet')
      } else {
        this.$swal(`Oops!`, res.data, 'error')
      }
      this.loadingForm = false
    },
    async fetchCrewInFleet() {
      try {
        this.loadingActiveCrew = true
        if (!this.$route.query.vehicleId)
          return console.log('THIS VEHICLE DOESNT EXIST')

        const res = await this.getCrewInFleet({
          vehicle_id: this.$route.query.vehicleId,
        })

        if (res.status) {
          res.data.map((val) => {
            if (val.status_emp_crewing?.name === 'Active') {
              this.crewActiveInFleet.push({
                ...val,
              })
            } else {
              this.crewHistoryInFleet.push({
                ...val,
              })
            }
          })
        }
      } catch (error) {
        console.log(error)
      }
      this.loadingActiveCrew = false
    },
    async onDeleteFleet(dataVal) {
      let data = dataVal

      this.$swal({
        title: 'Delete Fleet?',
        text: `Fleet ${data?.name} will be deleted and cannot be recovered.`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Delete',
      }).then(async (result) => {
        if (result.isConfirmed) {
          let res = await this.deleteFleet(data.id)
          if (res.status != 'success') {
            if (res.data.message != null) {
              this.$swal('Error', res.data.message, 'error')
            } else {
              this.$swal(
                'Error',
                'Something wrong with the server. Cannot get user data.',
                'error'
              )
            }
          } else {
            this.$swal(
              `Fleet deleted!`,
              `Fleet ${data?.name} successfully deleted`,
              'success'
            )
            this.$router.push({ name: 'dashboard.pms' })
          }
        }
      })
    },
    async fetchStatsCertificate() {
      let param = {
        vehicleId: this.vehicleId,
      }
      let res = await this.getStatsCertificate(param)
      if (res.data) {
        const data = res.data
        this.statsCertificateData.totalCertificate = data.totalCertificate
        this.statsCertificateData.totalExpired = data.totalExpired
        this.statsCertificateData.totalOneMonth = data.totalOneMonth
        this.statsCertificateData.totalProcess = data.totalProcess
      }
    },
    zoomUpdate(zoom) {
      this.currentZoom = zoom
    },
    centerUpdate(center) {
      this.currentCenter = center
    },
    getLatLng(lat, lng) {
      return latLng(lat, lng)
    },
    getIcon(icon) {
      if (!icon || !icon.url) {
        return 'fleet/PusherTug.png'
      }

      return this.$options.filters.checkPhoto(icon.url, 'fleet/PusherTug.png')
    },
    async getLastActivity() {
      this.activityList = []
      const vehicleId = this.$route.query.vehicleId
      let params = {
        page: 1,
      }
      const payload = {
        vehicleId: vehicleId,
        params,
      }
      const res = await this.getVoyageLastActivity(payload)
      if (res.status == 'success') {
        if (res.data && res.data?.length > 0) {
          this.activityList = res.data
        }
      } else {
        this.$swal(`Oops!`, res.data, 'error')
      }
    },
  },
}
</script>
<style scoped>
.font-semibold {
  font-weight: 500;
}
.tab-btn {
  background: #f3f4f6; /* abu default */
  color: #6b7280;
  font-weight: 600;
  cursor: pointer;
  transition: 0.2s;
  border-radius: 8px;
}
.tab-btn:hover {
  background: #e5e7eb;
}
.tab-btn.active {
  background: #d6e4ff; /* biru muda */
  color: #1d4ed8; /* biru teks */
}
</style>
